<script>
    import { Route, Router } from "svelte-navigator";
    import Approval from "../_Home/_Statistics/Approval.svelte";
    import NewCampaign from "./_Campaigns/NewCampaign.svelte";
    import Campaigns from "./_Campaigns/Campaigns.svelte";
    import Creatives from "./_Creatives/Creatives.svelte";
</script>

<Router>
    <Route path="campaigns">
        <Campaigns />
    </Route>
    <Route path="campaigns/:id" let:params>
        <NewCampaign id={params.id} />
    </Route>
    <Route path="campaigns/new">
        <NewCampaign />
    </Route>
    <Route path="creatives">
        <Creatives />
    </Route>
    <Route path="approval">
        <Approval />
    </Route>
</Router>
